function $c2465f885da9bd1c$export$2e2bcd8739ae039() {
    const toggleButton = document.querySelector('.nav__toggle');
    const navOverlay = document.querySelector('.nav__overlay');
    const body = document.body;
    if (!toggleButton || !navOverlay) {
        console.error('Required elements not found.');
        return;
    }
    const closeMenu = ()=>{
        toggleButton.setAttribute('aria-expanded', 'false');
        navOverlay.setAttribute('aria-hidden', 'true');
        body.classList.remove('no-scroll'); // Enable scrolling
    };
    const openMenu = ()=>{
        toggleButton.setAttribute('aria-expanded', 'true');
        navOverlay.setAttribute('aria-hidden', 'false');
        body.classList.add('no-scroll'); // Disable scrolling
    };
    const toggleMenu = ()=>{
        const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
        if (isExpanded) closeMenu();
        else openMenu();
    };
    // Ensure menu closes on desktop viewport
    window.addEventListener('resize', ()=>{
        if (window.innerWidth >= 768) closeMenu();
    });
    // Close menu on outside click
    const handleClickOutside = (event)=>{
        if (!navOverlay.contains(event.target) && !toggleButton.contains(event.target)) closeMenu();
    };
    // Close menu on Escape key
    const handleEscapeKey = (event)=>{
        if (event.key === 'Escape') closeMenu();
    };
    toggleButton.addEventListener('click', toggleMenu);
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);
}


function $c221a36a605c48cc$export$2e2bcd8739ae039() {
    const header = document.querySelector('.header');
    const topBar = document.querySelector('.top-bar');
    let lastScrollY = window.scrollY;
    let isSticky = false;
    let isHidden = false;
    let scrollDeltaDown = 0;
    function handleScroll() {
        const currentScrollY = window.scrollY;
        const topBarHeight = topBar?.offsetHeight || 43;
        const isDesktop = window.innerWidth >= 768;
        if (currentScrollY <= topBarHeight) {
            header.classList.remove('header--sticky');
            isSticky = false;
            header.classList.remove('header--hidden');
            isHidden = false;
            if (isDesktop) {
                const shiftX = '-50%';
                const shiftY = -currentScrollY;
                header.style.transform = `translate(${shiftX}, ${shiftY}px)`;
            } else header.style.transform = `translateY(${-currentScrollY}px)`;
            scrollDeltaDown = 0;
        } else {
            if (!isSticky) {
                header.classList.add('header--sticky');
                isSticky = true;
                header.style.transform = '';
            }
            if (currentScrollY > lastScrollY) {
                const delta = currentScrollY - lastScrollY;
                scrollDeltaDown += delta;
                if (scrollDeltaDown > 150 && !isHidden) {
                    header.classList.add('header--hidden');
                    isHidden = true;
                }
            } else {
                const delta = lastScrollY - currentScrollY;
                scrollDeltaDown = 0;
                if (delta > 10 && isHidden) {
                    header.classList.remove('header--hidden');
                    isHidden = false;
                }
            }
        }
        lastScrollY = currentScrollY;
    }
    function handleResize() {
        if (window.innerWidth < 768) {
            header.classList.remove('header--sticky', 'header--hidden');
            isSticky = false;
            isHidden = false;
            header.style.transform = '';
            lastScrollY = window.scrollY;
            scrollDeltaDown = 0;
        }
    }
    window.addEventListener('scroll', handleScroll, {
        passive: true
    });
    window.addEventListener('resize', handleResize);
    handleScroll();
    handleResize();
}


function $bd03061fe05e4ccd$export$2e2bcd8739ae039() {
    const playButton = document.querySelector(".hero__play-button");
    const overlay = document.getElementById("videoOverlay");
    const closeButton = document.querySelector(".hero__overlay-close");
    const videoContainer = document.getElementById("videoContainer");
    // Return early if hero elements don't exist on this page
    if (!overlay) return;
    if (playButton) playButton.addEventListener("click", function() {
        const videoUrl = playButton.getAttribute("data-video");
        if (videoUrl) {
            console.log("Video URL:", videoUrl);
            let videoId = "";
            // Convert "youtu.be/xyz" to "youtube.com/embed/xyz"
            if (videoUrl.includes("youtu.be")) videoId = videoUrl.split("youtu.be/")[1]; // Extract ID
            else if (videoUrl.includes("watch?v=")) videoId = new URL(videoUrl).searchParams.get("v"); // Extract ID
            if (videoId) {
                const youtubeEmbedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
                console.log("Embedding YouTube video:", youtubeEmbedUrl);
                videoContainer.innerHTML = `
            <iframe width="100%" height="100%" src="${youtubeEmbedUrl}"
            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          `;
                overlay.classList.add("show");
            }
        }
    });
    if (closeButton) closeButton.addEventListener("click", function() {
        console.log("Close button clicked!");
        overlay.classList.remove("show");
        videoContainer.innerHTML = ""; // Stop the video
    });
    // Close overlay when clicking outside the video
    overlay.addEventListener("click", function(event) {
        if (event.target === overlay) {
            overlay.classList.remove("show");
            videoContainer.innerHTML = "";
        }
    });
}


function $8b442a22cb289bbc$export$2e2bcd8739ae039() {
    const links = document.querySelectorAll('.intro__nav-link');
    const texts = document.querySelectorAll('.intro__text');
    function showLanguage(lang) {
        texts.forEach((text)=>{
            text.style.display = text.dataset.langContent === lang ? 'block' : 'none';
        });
    }
    links.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            e.preventDefault();
            const lang = link.dataset.lang;
            links.forEach((l)=>l.classList.remove('active'));
            link.classList.add('active');
            showLanguage(lang);
        });
    });
    // Show the first language by default
    if (links.length > 0) {
        links[0].classList.add('active');
        showLanguage(links[0].dataset.lang);
    }
}


function $ed508d573553a4f2$export$2e2bcd8739ae039() {
    const navButtons = document.querySelectorAll('.feature-highlights__nav-button');
    const mediaItems = document.querySelectorAll('.feature-highlights__media-item');
    if (navButtons.length === 0 || mediaItems.length === 0) {
        console.warn("Feature Highlights: No nav buttons or media items found.");
        return;
    }
    function showMedia(index) {
        mediaItems.forEach((item)=>{
            if (item.dataset.index === index) item.classList.add("visible");
            else item.classList.remove("visible");
        });
    }
    navButtons.forEach((button)=>{
        button.addEventListener("click", (e)=>{
            e.preventDefault();
            const index = button.dataset.index;
            // Deactivate all nav buttons, activate the clicked one
            navButtons.forEach((btn)=>btn.classList.remove("active"));
            button.classList.add("active");
            // Show the corresponding media item
            showMedia(index);
        });
    });
    // Activate the first button by default
    navButtons[0].classList.add("active");
    showMedia(navButtons[0].dataset.index);
}


function $505d528830c63ceb$export$2e2bcd8739ae039() {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchModal = document.getElementById('search-modal');
    const searchClose = document.querySelector('[data-search-close]');
    const searchInput = searchModal?.querySelector('.search-modal__input');
    const body = document.body;
    const navToggle = document.querySelector('.nav__toggle');
    const navOverlay = document.querySelector('.nav__overlay');
    if (!searchToggle || !searchModal) return; // Search elements not found on this page
    const closeModal = ()=>{
        searchModal.setAttribute('aria-hidden', 'true');
        body.classList.remove('no-scroll');
        searchToggle.focus(); // Return focus to toggle button
    };
    const openModal = ()=>{
        searchModal.setAttribute('aria-hidden', 'false');
        body.classList.add('no-scroll');
        // Close navigation menu if open
        if (navToggle && navOverlay) {
            navToggle.setAttribute('aria-expanded', 'false');
            navOverlay.setAttribute('aria-hidden', 'true');
        }
        // Focus the search input when modal opens
        setTimeout(()=>{
            searchInput?.focus();
        }, 100);
    };
    const handleEscapeKey = (event)=>{
        if (event.key === 'Escape' && searchModal.getAttribute('aria-hidden') === 'false') closeModal();
    };
    const handleClickOutside = (event)=>{
        if (searchModal.getAttribute('aria-hidden') === 'false') {
            const modalContent = searchModal.querySelector('.search-modal__content');
            if (!modalContent.contains(event.target)) closeModal();
        }
    };
    // Event listeners
    searchToggle.addEventListener('click', openModal);
    if (searchClose) searchClose.addEventListener('click', closeModal);
    document.addEventListener('keydown', handleEscapeKey);
    searchModal.addEventListener('click', handleClickOutside);
}


function $b01749c78de9c2fd$export$2e2bcd8739ae039() {
    const CONSENT_KEY = 'cookie-consent';
    const ANALYTICS_KEY = 'analytics-consent';
    const banner = document.getElementById('cookie-consent');
    const settingsModal = document.getElementById('cookie-settings');
    const analyticsCheckbox = document.getElementById('cookie-analytics');
    if (!banner) return;
    // Check if consent has already been given
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) // Show banner on first visit
    showBanner();
    else {
        // Load analytics if consent was given
        const analyticsConsent = localStorage.getItem(ANALYTICS_KEY);
        if (analyticsConsent === 'true') loadAnalytics();
    }
    // Accept all button
    const acceptButton = document.querySelector('[data-cookie-accept]');
    if (acceptButton) acceptButton.addEventListener('click', ()=>{
        saveConsent(true);
        hideBanner();
        loadAnalytics();
    });
    // Reject button (only necessary cookies)
    const rejectButton = document.querySelector('[data-cookie-reject]');
    if (rejectButton) rejectButton.addEventListener('click', ()=>{
        saveConsent(false);
        hideBanner();
    });
    // Settings button
    const settingsButton = document.querySelector('[data-cookie-settings]');
    if (settingsButton) settingsButton.addEventListener('click', ()=>{
        hideBanner();
        showSettings();
    });
    // Close settings modal
    const closeButtons = document.querySelectorAll('[data-settings-close]');
    closeButtons.forEach((button)=>{
        button.addEventListener('click', ()=>{
            hideSettings();
        });
    });
    // Save settings button
    const saveButton = document.querySelector('[data-settings-save]');
    if (saveButton) saveButton.addEventListener('click', ()=>{
        const analyticsEnabled = analyticsCheckbox.checked;
        saveConsent(analyticsEnabled);
        hideSettings();
        if (analyticsEnabled) loadAnalytics();
    });
    // Update checkbox based on current consent
    if (analyticsCheckbox) {
        const currentConsent = localStorage.getItem(ANALYTICS_KEY);
        analyticsCheckbox.checked = currentConsent === 'true';
    }
    // Helper functions
    function showBanner() {
        banner.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cookie-consent-visible');
    }
    function hideBanner() {
        banner.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('cookie-consent-visible');
    }
    function showSettings() {
        settingsModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('no-scroll');
    }
    function hideSettings() {
        settingsModal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('no-scroll');
    }
    function saveConsent(analyticsEnabled) {
        localStorage.setItem(CONSENT_KEY, 'true');
        localStorage.setItem(ANALYTICS_KEY, analyticsEnabled ? 'true' : 'false');
    }
    function loadAnalytics() {
        // Dispatch custom event that analytics scripts can listen to
        window.dispatchEvent(new CustomEvent('analyticsConsentGiven'));
        // Set flag for inline scripts to check
        window.analyticsConsent = true;
        // Load Matomo
        if (typeof _paq === 'undefined') loadMatomoScript();
        // Load Fathom
        if (!document.querySelector('script[src*="usefathom.com"]')) loadFathomScript();
    }
    function loadMatomoScript() {
        window._paq = window._paq || [];
        _paq.push([
            'trackPageView'
        ]);
        _paq.push([
            'enableLinkTracking'
        ]);
        const script = document.createElement('script');
        script.async = true;
        script.src = '//js-matomo.frb.io/matomo.js';
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
        _paq.push([
            'setTrackerUrl',
            '//js-matomo.frb.io/matomo.php'
        ]);
        _paq.push([
            'setSiteId',
            '1'
        ]);
    }
    function loadFathomScript() {
        const script = document.createElement('script');
        script.src = 'https://cdn.usefathom.com/script.js';
        script.setAttribute('data-site', 'UZEGYTLK');
        script.defer = true;
        document.head.appendChild(script);
    }
    // Expose function to open settings from privacy page
    window.openCookieSettings = function() {
        showSettings();
    };
}


document.addEventListener("DOMContentLoaded", ()=>{
    (0, $c2465f885da9bd1c$export$2e2bcd8739ae039)();
    (0, $c221a36a605c48cc$export$2e2bcd8739ae039)();
    (0, $bd03061fe05e4ccd$export$2e2bcd8739ae039)();
    (0, $8b442a22cb289bbc$export$2e2bcd8739ae039)();
    (0, $ed508d573553a4f2$export$2e2bcd8739ae039)();
    (0, $505d528830c63ceb$export$2e2bcd8739ae039)();
    (0, $b01749c78de9c2fd$export$2e2bcd8739ae039)();
});


//# sourceMappingURL=main.js.map
